import http from './http.service';

class CityService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/cities";
    }

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activate`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivate`, { params: { id: id } });
    }
}

export default new CityService();
